var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.789551C4.97715 0.789551 0.5 5.2667 0.5 10.7896C0.5 16.3124 4.97715 20.7896 10.5 20.7896C16.0228 20.7896 20.5 16.3124 20.5 10.7896C20.4936 5.26937 16.0202 0.79598 10.5 0.789551Z",
    fill: "#078D45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2724 7.62292L10.5683 15.3638C10.4322 15.5442 10.2294 15.6625 10.0053 15.692C9.78118 15.7214 9.55465 15.6596 9.37659 15.5204L5.30325 12.2638C4.94381 11.9761 4.8856 11.4515 5.17325 11.0921C5.4609 10.7326 5.98547 10.6744 6.34492 10.9621L9.74159 13.6796L14.9308 6.63709C15.1009 6.38175 15.3976 6.24058 15.7031 6.26962C16.0086 6.29867 16.2734 6.49323 16.3923 6.77607C16.5113 7.0589 16.4653 7.38425 16.2724 7.62292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.23556578fc7bd82f895330b4dd3b9504.svg";
export { ForwardRef as ReactComponent };